import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtPrice } from "@/lib/api";
import { toast } from "sonner";

export default function AdminProjects() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => {
    api.get("/admin/projects").then((r) => setItems(r.data.items || []));
  };
  useEffect(load, []);

  const filtered = items.filter((p) => filter === "all" || (p.publish_status || (p.published ? "published" : "draft")) === filter);

  const remove = async (slug) => {
    if (!window.confirm(`Delete project "${slug}"?`)) return;
    await api.delete(`/admin/projects/${slug}`);
    toast.success("Project deleted");
    load();
  };

  const translateAll = async () => {
    if (!window.confirm("Translate every project into all 6 languages using Emergent LLM? This can take a minute.")) return;
    toast.info("Starting bulk translation…");
    try {
      const { data } = await api.post("/admin/translate/bulk?entity=project&langs=ar,ru,zh,fr,ja,ko&limit=50");
      toast.success(`Translated ${data.processed} projects into ${data.langs.length} languages`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Bulk translation failed");
    }
  };

  return (
    <div className="p-10" data-testid="admin-projects">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <div className="text-xs tracking-[0.24em] uppercase text-gray-500 mb-1">Inventory</div>
          <h1 className="font-serif text-4xl">Projects</h1>
        </div>
        <div className="flex gap-3">
          <button
            onClick={translateAll}
            data-testid="project-translate-all"
            className="px-5 py-3 border border-[#001588] text-[#001588] text-sm uppercase tracking-[0.2em] hover:bg-[#001588] hover:text-white transition-colors"
          >Translate all</button>
          <Link
            to="/admin/projects/new"
            data-testid="admin-project-new-btn"
            className="px-5 py-3 bg-[#001588] text-white text-sm uppercase tracking-[0.2em] hover:bg-black transition-colors"
          >
            + New project
          </Link>
        </div>
      </div>

      <div className="flex gap-2 mb-5">
        {["all", "published", "review", "draft"].map((k) => (
          <button
            key={k}
            data-testid={`admin-project-filter-${k}`}
            onClick={() => setFilter(k)}
            className={`px-4 py-2 text-xs uppercase tracking-[0.2em] border transition-colors ${
              filter === k ? "bg-[#001588] text-white border-[#001588]" : "bg-white text-gray-700 border-[#E5E7EB]"
            }`}
          >
            {k}
          </button>
        ))}
      </div>

      <div className="border border-[#E5E7EB] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-[#E5E7EB] text-left uppercase text-xs tracking-wider text-gray-500">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Community</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Starting price</th>
              <th className="px-4 py-3">Publish</th>
              <th className="px-4 py-3">Source</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB]">
            {filtered.map((p) => (
              <tr key={p.id} data-testid={`admin-project-row-${p.slug}`}>
                <td className="px-4 py-3 font-medium">{p.name}</td>
                <td className="px-4 py-3 text-gray-600">{p.community || "—"}</td>
                <td className="px-4 py-3">
                  <span className="text-xs px-2 py-1 bg-gray-100 border border-[#E5E7EB]">{p.status || "—"}</span>
                </td>
                <td className="px-4 py-3">{p.starting_price ? fmtPrice(p.starting_price, p.currency) : "—"}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-1 border ${
                    (p.publish_status === "published" || p.published) ? "bg-emerald-50 border-emerald-200 text-emerald-800" :
                    p.publish_status === "review" ? "bg-amber-50 border-amber-200 text-amber-800" :
                    "bg-gray-50 border-gray-200 text-gray-700"
                  }`}>
                    {p.publish_status || (p.published ? "published" : "draft")}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-gray-500">{p.import_source || "manual"}</td>
                <td className="px-4 py-3 text-right space-x-3">
                  <Link to={`/admin/projects/${p.slug}/edit`} data-testid={`admin-project-edit-${p.slug}`} className="text-[#001588] hover:underline text-xs uppercase tracking-wider">Edit</Link>
                  <button onClick={() => remove(p.slug)} data-testid={`admin-project-delete-${p.slug}`} className="text-red-600 hover:underline text-xs uppercase tracking-wider">Delete</button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-gray-500">No projects found for this filter.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
